import { Checkbox } from '@dreryk/react-components';

import { commonTranslationKeys } from '../../../../../translations';
import { MedicalLeaveCommonFormController } from '../../common.types';
import { MedicalLeaveFormSectionColumn } from '../../MedicalLeaveFormSectionColumn/MedicalLeaveFormSectionColumn';

type MedicalLeaveFormMedicalIndicationsProps = {
   readonly controller: MedicalLeaveCommonFormController;
};

const MedicalLeaveFormMedicalIndications = (props: MedicalLeaveFormMedicalIndicationsProps): JSX.Element => (
   <MedicalLeaveFormSectionColumn title={commonTranslationKeys.medicalIndications}>
      <Checkbox
         controller={props.controller.register('canWalk')}
         label={commonTranslationKeys.canWalk}
         testId='canWalk'
      />
   </MedicalLeaveFormSectionColumn>
);

export { MedicalLeaveFormMedicalIndications };
